module.exports = __webpack_public_path__ + "img/exclamation-triangle.b34a56fe.svg";